import { render } from "./PartsVariousSourcesTable.vue?vue&type=template&id=487483b6&scoped=true"
import script from "./PartsVariousSourcesTable.vue?vue&type=script&lang=js"
export * from "./PartsVariousSourcesTable.vue?vue&type=script&lang=js"

import "./PartsVariousSourcesTable.vue?vue&type=style&index=0&id=487483b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487483b6"]])

export default __exports__